// @flow
import $ from 'jquery';
import dayjs from 'dayjs';

const addJQueryValidationExtendions = () => {
  $.validator.addMethod('regex', (value, element, regexp) => {
    if (regexp.constructor !== RegExp) regexp = new RegExp(regexp);
    else if (regexp.global) regexp.lastIndex = 0;
    return regexp.test(value);
  });

  $.validator.addMethod(
    'filesize',
    (value, element, params) =>
      !element.files[0] || element.files[0].size <= params,
  );

  $.validator.addMethod(
    'blankRange',
    (_value, _element, params) => {
      const { allow, picker } = params;
      return (
        allow ||
        !picker.startDate ||
        (picker.startDate.diff(picker.endDate, 'minutes') &&
          picker.startDate < picker.endDate)
      );
    },
    '開催日時の形式が正しくありません。',
  );

  $.validator.addMethod('extension', (value, element, param) => {
    if (!element.files[0]) return true;
    param =
      typeof param === 'string' ? param.replace(/,/g, '|') : 'png|jpe?g|gif';
    return value.match(new RegExp(`.(${param})$`, 'i'));
  });

  $.validator.addMethod(
    'fileSizeColletions',
    (value, element, params) =>
      params.container.maxFileSize(element.name) <= params.maxSize,
  );

  $.validator.addMethod('fileExtensionColletions', (value, element, param) => {
    const regex = new RegExp(`.(${param.regex})$`, 'i');
    return param.container
      .selectedFilesOf(element.name)
      .every(file => regex.test(file.name));
  });

  $.validator.addMethod(
    'limitQuantityFile',
    (value, element, params) =>
      params.container.countTotalFile(element.name) <= params.limited,
    'アップロード可能の最大ファイル数は5ファイルです。',
  );

  $.validator.addMethod(
    'limitFile',
    (value, element, params) => element.files.length <= params,
    'アップロード可能の最大ファイル数は5ファイルです。',
  );

  $.validator.addMethod(
    'validDate',
    value => dayjs(value, 'YYYY/MM/DD', true).isValid(),
    'invalid',
  );

  $.validator.addMethod(
    'validDateIfHaveData',
    (value, element) => {
      const elementScope = element.closest('.form-group');
      const year = $(elementScope)
        .find('input[name="year"]')
        .val();
      const month = `0${$(elementScope)
        .find('input[name="month"]')
        .val()}`.slice(-2);
      const day = `0${$(elementScope)
        .find('input[name="day"]')
        .val()}`.slice(-2);
      if (year === '' && month === '0' && day === '0') {
        return true;
      }
      if (year === '0' || month === '0' || day === '0') {
        return false;
      }
      return dayjs(value, 'YYYY/MM/DD', true).isValid();
    },
    'invalid',
  );

  $.validator.addMethod(
    'greaterThanCurrentTime',
    value => {
      const date = new Date(value);
      const currentDate = new Date();
      return date > currentDate;
    },
    '現在の日時後の日時を入力してください。',
  );

  $.validator.addMethod(
    'greaterThanEqualCurrentDate',
    value => {
      const date = new Date(value).setHours(0, 0, 0, 0);
      const currentDate = new Date().setHours(0, 0, 0, 0);
      return date >= currentDate;
    },
    '現在の日時後の日時を入力してください。',
  );

  $.validator.addMethod(
    'lessThanEqualCurrentDate',
    value => {
      const date = new Date(value).setHours(0, 0, 0, 0);
      const currentDate = new Date().setHours(0, 0, 0, 0);
      return date <= currentDate;
    },
    'invalid',
  );

  $.validator.addMethod(
    'greaterThanEqualDateTo',
    (value, _element, param) => {
      const otherValue = $(param).val();
      if (!otherValue) return true;
      const date = new Date(value).setHours(0, 0, 0, 0);
      const otherDate = new Date(otherValue).setHours(0, 0, 0, 0);
      return date >= otherDate;
    },
    '失効期限の形式が正しくありません。',
  );

  $.validator.addMethod(
    'greaterThan',
    (value, element, param) => {
      return parseInt(value.replace(/,/g, ''), 10) > param || value === '';
    },
    'Please enter a greater value.',
  );

  $.validator.addMethod(
    'lessThan',
    (value, element, param) => {
      const $target = $(param);
      return value < $target.val() || $target.val() === '' || value === '';
    },
    'Please enter a less value.',
  );

  $.validator.addMethod(
    'lessThanEqual',
    (value, element, param) => {
      if (
        $(element.closest('form')).hasClass('required-if-any-data') &&
        value === ''
      ) {
        return true;
      }
      return dayjs(value, 'YYYY/MM/DD') <= param.endOf('day');
    },
    'Please enter a less value.',
  );

  $.validator.addMethod(
    'greaterThanEqual',

    (value, element, param) => {
      if (
        $(element.closest('form')).hasClass('required-if-any-data') &&
        value === ''
      ) {
        return true;
      }
      return dayjs(value, 'YYYY/MM/DD') >= param.startOf('day');
    },
    'Please enter a greater value.',
  );

  $.validator.addMethod(
    'collectionValidate',
    (value, element, param) => {
      const values = param.valuesSelector(value, element, param);
      return param.validator(values, value, element, param);
    },
    'invalid',
  );

  $.validator.addMethod(
    'uniqCollectionValidate',
    (_value, _element, param) =>
      !param.arr.every((val, _i, arr) => val === arr[0]),
    'invalid',
  );

  $.validator.addMethod(
    'requiredWithTrimInput',
    (value, element, param) => {
      const newValue = value.trimStart();
      let isRequired = param;
      if ($.isFunction(param)) isRequired = param(value, element, param);
      $(element).val(newValue);
      if (!newValue && isRequired) return false;
      return true;
    },
    'This field is required',
  );

  $.validator.addMethod(
    'remoteValidate',
    (value, element, param) =>
      $.get({
        url: param.url,
        data: param.data(value, element),
        async: false,
      }).responseJSON,
  );

  $.validator.addMethod(
    'requireCollectionValidate',
    (_value, element) =>
      !!$(element)
        .closest('.form-group')
        .find('input:checked').length,
    'invalid',
  );

  $.validator.addMethod(
    'requireIfHaveData',
    (value, element, param) => {
      const closestFrom = $(element).closest('form');
      const condition = param
        .split(' ')
        .every(attribute => closestFrom.find(`.${attribute}`).val() === '');
      if (param.match('first_name|last_name')) {
        return value !== '';
      }
      if (!condition) {
        return value !== '';
      }
      return condition;
    },
    'Please enter a less value.',
  );
};

export default addJQueryValidationExtendions();
